import { render, staticRenderFns } from "./RentalSection.vue?vue&type=template&id=12195f2d&scoped=true"
var script = {}
import style0 from "./RentalSection.vue?vue&type=style&index=0&id=12195f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12195f2d",
  null
  
)

export default component.exports